import { useTranslation } from "react-i18next";
import { useTableQueryResult } from "./data-table-context";

// "No results found." is only honest when the request came back empty. When it failed, the table
// is empty for a completely different reason, and saying "no results" tells the user their filter
// matched nothing when the truth is we never got an answer. Since the error toast is SuperAdmin
// only, this empty state is the one signal everyone else gets that something went wrong.
export const useNoResultsMessage = (noResultsMessage: string) => {
  const { t } = useTranslation();
  // Tables built on local or static data render outside TableQueryResultContext -- no query, so
  // nothing to have failed.
  const queryResult = useTableQueryResult();
  return queryResult?.isError
    ? t("failedToLoadResults", {
        defaultValue: "Couldn't load results. Please try again.",
      })
    : noResultsMessage;
};
